export default {
  accessToken: "",
  me: null, //내 정보,
  kakaoInfo: null, // 채널 + 카카오 사용자 key
  hospital: null, // 
  certifyCard: "", // 인증받은 카드
  certifyUser: ""  // 인증받은 사용자
};
